
















import { Component, Mixins } from 'vue-property-decorator';
import { Mutations } from '@/ts/store/Constants';
import BackButton from '@/components/Buttons/BackButton.vue';
import LocalizationMethods from '@/mixins/LocalizationMethods.vue';
import DeviceMethods from '@/mixins/DeviceMethods.vue';
import AddNewTicketForm from '@/components/User/Panels/AddNewTicketForm.vue';

@Component({
    components: {
        BackButton,
        AddNewTicketForm,
    },
})
export default class ReportIssue extends Mixins(LocalizationMethods, DeviceMethods) {
    public closeOverlay() {
        this.$store.commit(Mutations.SET_REPORT_ISSUE_OVERLAY_VISIBILITY, false);
    }
}
